import React from "react";
import { FaEdit, FaIdCard } from "react-icons/fa";
import { Card } from "../UI/DesignStandards";
import { PrimaryButton, SecondaryButton } from "../UI/DesignStandards/Buttons";

const UsbcIdSection = ({
  usbcId,
  editingUsbcId,
  loading,
  error,
  onEdit,
  onSave,
  onCancel,
  onChange,
}) => {
  return (
    <Card className="mb-0" aria-labelledby="usbc-id-heading">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div
            className="w-10 h-10 bg-brand-cream rounded-lg flex items-center justify-center"
            aria-hidden="true"
          >
            <FaIdCard className="h-5 w-5 text-brand-muted" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-3 gap-2">
            <h3 id="usbc-id-heading" className="heading-display text-lg">
              USBC ID
            </h3>
            {!editingUsbcId ? (
              <SecondaryButton
                onClick={onEdit}
                icon={FaEdit}
                className="!px-3 !py-2 text-sm"
                aria-label="Edit USBC ID"
              >
                Edit
              </SecondaryButton>
            ) : (
              <div className="flex gap-2">
                <PrimaryButton
                  onClick={onSave}
                  disabled={loading}
                  loading={loading}
                  loadingText="Saving..."
                  aria-label={
                    loading ? "Saving USBC ID" : "Save USBC ID changes"
                  }
                >
                  Save
                </PrimaryButton>
                <SecondaryButton
                  onClick={onCancel}
                  className="!px-3 !py-2 text-sm"
                  aria-label="Cancel USBC ID changes"
                >
                  Cancel
                </SecondaryButton>
              </div>
            )}
          </div>

          {!editingUsbcId ? (
            <div className="p-3 card-inset">
              <p className="text-brand-charcoal font-medium font-score">
                {usbcId || (
                  <span className="text-brand-muted italic font-body">
                    Not set
                  </span>
                )}
              </p>
            </div>
          ) : (
            <div className="mt-3">
              <label
                htmlFor="usbcId"
                className="block text-sm font-medium text-brand-charcoal mb-2"
              >
                USBC ID
              </label>
              <div className="relative">
                <div
                  className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none z-10"
                  aria-hidden="true"
                >
                  <FaIdCard className="h-5 w-5 text-brand-muted" />
                </div>
                <input
                  type="text"
                  id="usbcId"
                  name="usbcId"
                  value={usbcId}
                  onChange={onChange}
                  className={`block w-full pl-12 px-4 py-3 border rounded-lg bg-white text-brand-charcoal font-score focus:outline-none focus:ring-2 ${
                    error
                      ? "border-red-300 focus:ring-red-500"
                      : "border-brand-charcoal/20 focus:ring-brand-gold-ink"
                  }`}
                  placeholder="Enter USBC ID"
                  aria-describedby={error ? "usbc-id-error" : "usbc-id-help"}
                  aria-invalid={error ? "true" : "false"}
                />
              </div>
              {error && (
                <p
                  id="usbc-id-error"
                  className="mt-1 text-sm text-red-600"
                  role="alert"
                >
                  {error}
                </p>
              )}
              <p id="usbc-id-help" className="mt-1 text-sm text-brand-muted">
                Enter your USBC ID (numbers only)
              </p>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default UsbcIdSection;
